export default __webpack_public_path__ + "static/media/18.1cc0ab41.jpg";